<form #f="ngForm" #sofForm="ngForm" (ngSubmit)="onSubmit(f)" enctype="multipart/form-data">
    <input type="hidden" name="id" placeholder="id" class="form-control form-control-sm" [(ngModel)]="quote.id">
    <h5 class="mb-4" style="line-height: 20px;">Please read all questions carefully and be sure to answer accurately in the correct box, as some questions will trigger an automatic exclusion if answered 'yes'. Where further information is required, please provide details of the condition(s) with the dates.</h5>

    <!-- General Statement of Facts -->
    <div *ngIf="generalStatementOfFacts.length > 0">
        <h5 class="mt-3 mb-3"><u>General Statement of Facts</u></h5>
        <div *ngFor="let statementOfFact of generalStatementOfFacts; let i = index;">
            <div class="form-group row">
                <div class="col-md-12">
                    <div class="quote_radio w-90">
                        <label class="p-3">
                            {{statementOfFact.display_order ? statementOfFact.display_order + '. ' : ''}}
                            {{replace_policy_holder_name(replace_horse_name(statementOfFact.description))}}
                        </label>
                    </div>
                    <span (click)="helpTextPopup(content, statementOfFact.description)"><i
                            class="mdi mdi-comment-question-outline ml-1"></i></span>
                </div>
            </div>
            <ng-container *ngIf="statementOfFact.type == 1 && getStatementOfFactForQuestion(statementOfFact.id) as sof">
                <div class="form-group row">
                    <div class="col-md-3"> 
                        <mat-radio-group aria-label="Select an option"
                            name="generalSof_{{sof.question_id}}"
                            [(ngModel)]="sof.response" (ngModelChange)="onSofResponseChange(sof, statementOfFact)" required #generalSofControl="ngModel">
                            <div class="quote_radio row mb-3">
                                <div class="col-md-6">
                                    <mat-radio-button [value]="1" 
                                        name="generalSof_{{sof.question_id}}"
                                        ngDefaultControl 
                                        [(ngModel)]="sof.response"
                                        required 
                                        #generalSofRadio="ngModel"
                                    >
                                        Agree
                                    </mat-radio-button>
                                </div>
                            </div>
                            <div *ngIf="(f.submitted || submitted) && generalSofControl.invalid" class="invalid-feedback col-md-12">
                                Please choose an option.
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="form-group row" *ngIf="(statementOfFact.show_textbox == 0 && sof.response == 2) || (statementOfFact.show_textbox == 1 && sof.response == 1)">
                    <div class="col-md-11">
                        <div *ngIf="statementOfFact.is_exclusion == 1 && statementOfFact.exclusion_text" class="alert alert-warning mb-2">
                            {{statementOfFact.exclusion_text}}
                        </div>
                        <textarea name="general_response_text_{{sof.question_id}}"
                            class="form-control" placeholder="Please provide response text"
                            [(ngModel)]="sof.response_text" #general_response_text="ngModel"
                            required [ngClass]="{ 'is-invalid': (f.submitted || submitted) && general_response_text.invalid }">
                        </textarea>
                        <div *ngIf="(f.submitted || submitted) && general_response_text.invalid" class="invalid-feedback">
                            Response text is required.
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="form-group row" *ngIf="statementOfFact.type == 2">
                <div class="col-md-11"> 
                    <input class="form-control" type="text" placeholder="Please provide details"
                        name="generalSofText_{{statementOfFact.id}}" [(ngModel)]="statementOfFact.response_text"
                        required #generalSofText="ngModel"
                        [ngClass]="{ 'is-invalid': submitted && generalSofText.invalid }">
                    <div *ngIf="submitted && generalSofText.invalid" class="invalid-feedback">
                        Please provide details.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Veterinary Statement of Facts -->
    <div *ngIf="veterinaryStatementOfFacts.length > 0">
        <h5 class="mt-3 mb-3"><u>Veterinary Statement of Facts</u></h5>
        <div *ngFor="let statementOfFact of veterinaryStatementOfFacts; let i = index;">
            <div class="form-group row">
                <div class="col-md-12">
                    <div class="quote_radio w-90">
                        <label class="p-3">
                            {{statementOfFact.display_order ? statementOfFact.display_order + '. ' : ''}}
                            {{replace_policy_holder_name(replace_horse_name(statementOfFact.description))}}
                        </label>
                    </div>
                    <span (click)="helpTextPopup(content, statementOfFact.description)"><i
                            class="mdi mdi-comment-question-outline ml-1"></i></span>
                </div>
            </div>
            <ng-container *ngIf="statementOfFact.type == 1 && getStatementOfFactForQuestion(statementOfFact.id) as sof">
                <div class="form-group row">
                    <div class="col-md-3"> 
                        <mat-radio-group aria-label="Select an option"
                            name="vetSof_{{sof.question_id}}"
                            [(ngModel)]="sof.response" (ngModelChange)="onSofResponseChange(sof, statementOfFact)" required #vetSofControl="ngModel">
                            <div class="quote_radio row mb-3">
                                <div class="col-md-6">
                                    <mat-radio-button [value]="1" 
                                        name="vetSof_{{sof.question_id}}"
                                        ngDefaultControl 
                                        [(ngModel)]="sof.response"
                                        required 
                                        #vetSofRadio="ngModel"
                                    >
                                        Yes
                                    </mat-radio-button>
                                </div>
                                <div class="col-md-6">
                                    <mat-radio-button 
                                        [value]="2" 
                                        name="vetSof_{{sof.question_id}}"
                                        ngDefaultControl 
                                        [(ngModel)]="sof.response"
                                        required 
                                        vetSofRadio="ngModel"
                                    >
                                        No
                                    </mat-radio-button>
                                </div>
                            </div>
                            <div *ngIf="(f.submitted || submitted) && vetSofControl.invalid" class="invalid-feedback col-md-12">
                                Please choose an option.
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="form-group row" *ngIf="(statementOfFact.show_textbox == 0 && sof.response == 2) || (statementOfFact.show_textbox == 1 && sof.response == 1)">
                    <div class="col-md-11">
                        <div *ngIf="statementOfFact.is_exclusion == 1 && statementOfFact.exclusion_text" class="alert alert-warning mb-2">
                            {{statementOfFact.exclusion_text}}
                        </div>
                        <textarea name="vet_response_text_{{sof.question_id}}"
                            class="form-control" placeholder="Please provide response text"
                            [(ngModel)]="sof.response_text" #vet_response_text="ngModel"
                            required [ngClass]="{ 'is-invalid': (f.submitted || submitted) && vet_response_text.invalid }">
                        </textarea>
                        <div *ngIf="(f.submitted || submitted) && vet_response_text.invalid" class="invalid-feedback">
                            Response text is required.
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="form-group row" *ngIf="statementOfFact.type == 2">
                <div class="col-md-11"> 
                    <input class="form-control" type="text" placeholder="Please provide details"
                        name="vetSofText_{{statementOfFact.id}}" [(ngModel)]="statementOfFact.response_text"
                        required #vetSofText="ngModel"
                        [ngClass]="{ 'is-invalid': submitted && vetSofText.invalid }">
                    <div *ngIf="submitted && vetSofText.invalid" class="invalid-feedback">
                        Please provide details.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="declarationStatementOfFacts.length > 0">
        <h5 class="mt-3 mb-3"><u>Declaration Statement of Facts</u></h5>
        <div *ngFor="let statementOfFact of declarationStatementOfFacts; let i = index;">
            <div class="form-group row">
                <div class="col-md-12">
                    <div class="quote_radio w-90">
                        <label class="p-3">
                            {{statementOfFact.display_order ? statementOfFact.display_order + '. ' : ''}}
                            {{replace_policy_holder_name(replace_horse_name(statementOfFact.description))}}
                        </label>
                    </div>
                    <span (click)="helpTextPopup(content, statementOfFact.description)">
                        <i class="mdi mdi-comment-question-outline ml-1"></i>
                    </span>
                </div>
            </div>
            <ng-container *ngIf="getStatementOfFactForQuestion(statementOfFact.id) as sof">
                <div class="form-group row">
                    <div class="col-md-3">
                        <mat-radio-group aria-label="Select an option"
                            name="declSof_{{sof.question_id}}"
                            [(ngModel)]="sof.response" required #declSofControl="ngModel">
                            <div class="quote_radio row mb-3">
                                <div class="col-md-6">
                                    <mat-radio-button [value]="1"
                                        name="declSof_{{sof.question_id}}"
                                        ngDefaultControl
                                        [(ngModel)]="sof.response"
                                        required
                                        #declSofRadio="ngModel"
                                    >
                                        Agree
                                    </mat-radio-button>
                                </div>
                            </div>
                            <div *ngIf="(f.submitted || submitted) && declSofControl.invalid" class="invalid-feedback col-md-12">
                                Please agree to continue.
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="form-group row">
        <div class="col-md-11">
            <label>Please upload any Clinical History, Veterinary Certificates/Reports, Purchase Receipts or other
                relevant information</label><br>
            <div class="form-group">
                <a (click)="uploadDocumentBtn(documents)" class="btn btn-success">Upload Document</a>
            </div>
        </div>
    </div>
    <ag-grid-angular
        style="width: 100%; height: 230px;float:left;"
        class="ag-theme-bootstrap"
        [gridOptions]="gridOptions"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        animateRows
        pagination
        paginationPageSize="5"
        rowHeight="27"
        headerHeight="35"
        (rowClicked)='onGridRowClicked($event,documents,documentsDelete)' 
    >
    </ag-grid-angular>
    <div class="form-group">
        <a (click)="backToClaimsTabButton()" class="btn btn-default btn-gray mr-3">Back</a>
        <button type="button" class="btn btn-success btn-gray mr-2" [disabled]="isSavingSof" (click)="continueToPremiumSummary()">Continue</button>
    </div>
</form>

<ng-template #content let-modal>
    <div class="modal-body">
        <div [innerHTML]="replace_policy_holder_name(replace_horse_name(helptext))"></div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
    </div>
</ng-template>

<ng-template #documents let-modal>
    <div class="modal-header">
        <h4>Document</h4>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label>Title</label>
            <input type="text" name="document_title" [(ngModel)]="docTitle" class="form-control form-control-sm">
        </div>
        <div class="form-group" *ngIf="!documentsEditMode">
            <label>Document</label>
            <div class="custom-file">
                <input type="file" name="file_name" (change)="getUploadedFile($event.target.files)"
                    class="custom-file-input" id="customFile">
                <label class="custom-file-label" for="customFile">{{quote.quote_document || 'Choose file'}}</label>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" *ngIf="!documentsEditMode" class="btn btn-success" (click)="documentUpload()">Upload</button>
        <button type="button" *ngIf="documentsEditMode" class="btn btn-success" (click)="updateDocument()">Update</button>
        <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
    </div>
</ng-template>

<ng-template #documentsDelete let-modal>
    <div class="modal-header">
        <h4>Delete Document</h4>
    </div>
    <div class="modal-body text-center">
        <img src="assets/images/deactivate.png" width="50"><br>
        Are you sure you want to delete document {{docTitle}}?
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="deleteDocument()">Yes</button>
        <button type="button" class="btn btn-default" (click)="modal.close()">No</button>
    </div>
</ng-template>
